export const environment = {
  production: true,
  baseUrl: 'http://127.0.0.1:8080',
  dev: false,
  apiUrl: 'https://api.alphta.de/wp-json/'
};
